module.exports = __webpack_public_path__ + "img/contact_05.36351896.png";